import { render } from "./GalleryView.vue?vue&type=template&id=27f572e3&scoped=true"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"

import "./GalleryView.vue?vue&type=style&index=0&id=27f572e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f572e3"]])

export default __exports__